import React, { Component, createRef } from 'react';

import { Form } from 'react-bootstrap';

import CommonButton from './CommonButton';

import * as util from '../../library/utilitys';
import { TimerSharp } from '@mui/icons-material';
class CommonFile extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = createRef(); 
        this.state = {confirmDelete: false}
    }

    confirmDelete = (bool) => {
        this.setState({ confirmDelete: bool });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.input.value !== this.props.input.value && this.props.input.value === '') {
            this.resetFileInput();
        }
    }

    resetFileInput = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = ''; 
            this.fileInputRef.current.classList.remove('is-valid', 'is-invalid');
            this.setState({ confirmDelete: false });
        }
    };

    render = () => {

        let { element, input, callback, previewFile, deleteFile, disabled = false, hr = false, floatingLabel = true, size = "md" } = this.props;

        let { id, label, placeholder = undefined, validator, error, fileId, fileName, value } = input;

        let { confirmDelete } = this.state;

        return (
                <>
                    {element === 'Inputs' && floatingLabel === true && (
                        <div className="mb-0">
                            <Form.Label className={size === 'sm' ? 'label-size-sm' : ''}>
                                {label}{' '}
                                {validator.required && (
                                    <i
                                    className="fa-classic fa-light fa-asterisk fa-fw"
                                    style={{
                                        fontSize: '0.5rem',
                                        verticalAlign: 'text-top'
                                    }}
                                    />
                                )}
                            </Form.Label>
                        </div>
                    )}

                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        <Form.Control
                            type="file"
                            ref={this.fileInputRef}
                            id={id}
                            name={`${element}_${id}`}
                            placeholder={placeholder || label}
                            className={`form-control ${error?.status === true ? "is-invalid" : (error?.status === false && (value !== '' || fileId != null)) ? "is-valid" : ""}`}
                            accept={validator?.accept}
                            onChange={(e) => callback(e, element)}
                            disabled={disabled}
                            style={{ minWidth: '200px', maxWidth: '600px' }}
                            size={size}
                        />

                        {(element === 'Inputs' && error?.status) && (
                        <>
                            <Form.Control.Feedback type="invalid" className="mt-2 ms-2" style={{ fontSize: '0.75rem' }}>
                                <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                                {error?.msg}
                            </Form.Control.Feedback>
                        </>
                    )}

                        {(!util.isEmpty(fileId)) && (
                            <>
                                <div className="w-100 d-flex align-items-center gap-2 flex-wrap mt-2">
                                    <CommonButton 
                                        task="preview-file" 
                                        rounded={true}
                                        disabled={disabled}
                                        size={size}
                                        callback={(e) => previewFile({id: fileId})}                                        
                                    />

                                    {!confirmDelete && (
                                        <CommonButton 
                                            task="delete-file" 
                                            rounded={true}
                                            disabled={disabled}
                                            size={size}
                                            callback={(e) => this.confirmDelete(true) } 
                                        />
                                    )}

                                    {confirmDelete && (
                                        <>
                                            <CommonButton 
                                                task="confirm-delete-file" 
                                                rounded={true}
                                                disabled={false}
                                                size={size}
                                                callback={(e) => deleteFile({ key: id, value: fileId}) } 
                                            />
                                            <CommonButton 
                                                task="discard-delete-file" 
                                                rounded={true}
                                                disabled={false}
                                                size={size}
                                                callback={(e) => this.confirmDelete(false) } 
                                            />
                                        </>
                                    )}
                                </div>

                                {fileName && (
                                    <div className="w-100 mt-1 ms-2">
                                        <span style={{ fontSize: '0.7rem', color: '#666' }}>
                                            {fileName}
                                        </span>
                                    </div>
                                )}
                            </>
                        )}
                    </div>

                    {hr && <hr className="hr-custom" />}
                </>

        );
    }
}

export default CommonFile;
